import { PaginationData, QueryParams } from 'shared/types';
import request from './requesters/service-provider.request';
import { WasteCenterType } from '../models';

const wasteCenterTypeService = {
  getWasteCenterTypes: (params: QueryParams) =>
    request.get<PaginationData<WasteCenterType>>('/waste-center-types', {
      params,
    }),
  multipleWasteCenterTypeUpdates: (data: { wasteCenterTypes: WasteCenterType[] }) =>
    request.put<WasteCenterType[]>('/waste-center-types/multiple-updates', data),
};

export default wasteCenterTypeService;
